import React from "react";

/**
 * A chevron that turns to show state. `direction` is where it points:
 * "end" follows the reading direction (right in English, left in Arabic);
 * "start" points back the other way.
 */
const ROTATION = {
  end: "rtl:rotate-180",
  start: "rotate-180 rtl:rotate-0",
  down: "rotate-90",
  up: "-rotate-90",
};

const Chevron = ({ direction = "end", className = "" }) => (
  <svg
    aria-hidden="true"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`w-6 h-6 shrink-0 transition-transform duration-200 ${ROTATION[direction]} ${className}`}
  >
    <path d="M9 5l7 7-7 7" />
  </svg>
);

export default Chevron;
